import React from 'react';

export default function Noise() {
	return <div className="noise"></div>;
}
